// Global initialization function for featured blog carousels
function initFeaturedBlogCarousel(sectionElement) {
  var options = {
    align: "start",
    skipSnaps: false,
    dragFree: false,
    containScroll: "keepSnaps",
  };

  var emblaNode = sectionElement.querySelector(
    ".featured-blog__carousel-container .embla"
  );
  if (!emblaNode) return;

  var viewportNode = emblaNode.querySelector(".embla__viewport");
  var embla = EmblaCarousel(viewportNode, options);

  var dotsNode = sectionElement.querySelector(".featured-blog__dots");
  var dotsArray = generateDots(dotsNode, embla.scrollSnapList());

  var selectedDotIndex = 0;
  if (dotsArray && dotsArray.length > 0) {
    dotsArray[selectedDotIndex].classList.add("featured-blog__dot--selected");
  }

  embla.on("select", function () {
    if (!dotsArray || dotsArray.length === 0) return;
    var previousDotIndex = selectedDotIndex;
    selectedDotIndex = embla.selectedScrollSnap();
    dotsArray[previousDotIndex].classList.remove(
      "featured-blog__dot--selected"
    );
    dotsArray[selectedDotIndex].classList.add("featured-blog__dot--selected");
  });

  if (dotsArray) {
    dotsArray.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        embla.scrollTo(index);
      });
    });
  }

  // Add click handlers for prev/next buttons
  const prevButton = sectionElement.querySelector(
    ".featured-blog__arrow--prev"
  );
  const nextButton = sectionElement.querySelector(
    ".featured-blog__arrow--next"
  );

  if (prevButton) {
    prevButton.addEventListener("click", function () {
      embla.scrollPrev();
    });
  }

  if (nextButton) {
    nextButton.addEventListener("click", function () {
      embla.scrollNext();
    });
  }
}

function generateDots(dotsNode, scrollSnaps) {
  if (!dotsNode) return [];

  var dotsHTML = scrollSnaps.reduce(function (acc, _, index) {
    var slideNumber = index + 1;
    return acc + '<button class="featured-blog__dot ecs-cards-carousel__dot" type="button" aria-label="Go to slide ' + slideNumber + '"></button>';
  }, "");

  dotsNode.innerHTML = dotsHTML;
  return Array.from(dotsNode.querySelectorAll(".featured-blog__dot"));
}

// Initialize all featured blog sections on the page
document.addEventListener("DOMContentLoaded", function () {
  var featuredBlogSections = document.querySelectorAll(".featured-blog-wrap");
  featuredBlogSections.forEach(function (section) {
    initFeaturedBlogCarousel(section);
  });
});
